/**
 * 英文（美版）语言包 - 汇总
 * Common + modules merged
 */
import common from './common/en-US'
import route from './modules/route/en-US'
import callCenter from './modules/callCenter/en-US'
import agentProvider from './modules/agentProvider/en-US'
import purchasing from './modules/purchasing/en-US'
import subscriptionCard from './modules/subscriptionCard/en-US'
import equipment from './modules/equipment/en-US'
import finance from './modules/finance/en-US'
import operateManage from './modules/operateManage/en-US'
import operationCenter from './modules/operationCenter/en-US'
import showCard from './modules/showCard/en-US'
import serviceCenter from './modules/serviceCenter/en-US'
import salesCenter from './modules/salesCenter/en-US'
import dataCenter from './modules/dataCenter/en-US'
import cockpit from './modules/cockpit/en-US'
import angentManage from './modules/angentManage/en-US'

export default {
  ...common,
  ...route,
  ...callCenter,
  ...agentProvider,
  ...purchasing,
  ...subscriptionCard,
  ...equipment,
  ...finance,
  ...operateManage,
  // Provide namespace access for keys used as `$t('operateManage.xxx')`
  // while keeping the original flat keys for backward compatibility.
  operateManage: operateManage,
  ...operationCenter,
  ...showCard,
  ...salesCenter,
  ...dataCenter,
  ...cockpit,
  ...angentManage,
  // Merge serviceCenter: common's serviceCenter is overwritten by modules/serviceCenter, need manual merge
  serviceCenter: {
    ...(common.serviceCenter || {}),
    ...(serviceCenter.serviceCenter || {})
  }
}
